import Typography from '@mui/material/Typography';
import { format } from 'date-fns';
import { Row } from '../../interfaces';
import AmountSection from '../../components/transactions/AmountSection';
import { HeaderCells } from '../../types/ui';
import {
  getPaymentMethodText,
  isFreeCheckout,
  isPaymentComplete,
  sortPaymentsByPaymentMethod,
} from '../../helpers/payments';
import { PaymentsGroup } from '../../types/payments';
import { getFullName } from '../../helpers/global';

export const headerCells = [
  { id: 'amount', label: 'Amount' },
  { id: 'paymentMethod', label: 'Payment method' },
  { id: 'customer', label: 'Client' },
  { id: 'createdAt', label: 'Date' },
] as const satisfies HeaderCells;

// Function to create a table row from an appointment data
function createRow(group: PaymentsGroup): Row {
  const completePayments = group.payments.filter(isPaymentComplete);
  const paymentMethodText = isFreeCheckout(completePayments)
    ? 'N/A'
    : Array.from(
        new Set(
          sortPaymentsByPaymentMethod(completePayments).map(payment =>
            getPaymentMethodText(payment.method),
          ),
        ),
      ).join('/') || 'N/A';

  const row = {
    rowId: group.groupKey,
    cells: [
      <AmountSection group={group} />,
      <Typography variant="body1">{paymentMethodText}</Typography>,
      <Typography variant="body1">
        {group.customer?.user ? getFullName(group.customer?.user) : 'N/A'}
      </Typography>,
      <Typography variant="body1">
        {format(
          new Date(group.payments?.[0]?.createdAt),
          'MMM d, yyyy, h:mm a',
        )}
      </Typography>,
    ],
  };

  return row;
}

// Function to create filtered rows based on appointment status
export function createRows({ items }: { items: PaymentsGroup[] | undefined }) {
  if (!items) {
    return [];
  }

  const rows: Row[] = items.map(item => createRow(item));

  return rows;
}
